import { render, staticRenderFns } from "./CreateFavouriteMarkets.vue?vue&type=template&id=613d10fc"
import script from "./CreateFavouriteMarkets.vue?vue&type=script&lang=js"
export * from "./CreateFavouriteMarkets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports